import { useSelector } from 'react-redux'
import { selectToken } from '../authentication/authenticationSlice'
import api from '../api'
import useDataLoader from '../dataLoader'

const useListManualExpenseSubcategories = (organizationId: number | null) => {
  const token = useSelector(selectToken)
  const fetchManualExpenseSubcategories = async () => {
    if (organizationId) {
      return await api.listManualExpenseSubcategories({ token, organizationId })
    }
  }

  return useDataLoader(fetchManualExpenseSubcategories, [], [])
}

export default useListManualExpenseSubcategories
